import { useFirebaseAuth } from '@smart-maps/firebase';
import classnames from 'classnames';
import { DateTime } from 'luxon';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { useSelector } from 'react-redux';

const useStyles = createUseStyles({
  activity: {
    composes: ['text-center', 'fs10'],
    letterSpacing: 0.02,
  },
  label: {
    composes: ['is-bold', 'mr6'],
  },
  value: {
    lineHeight: 0.9,
  },
});

const LastActivityComponent = React.memo(() => {
  const classes = useStyles();
  const { user } = useFirebaseAuth();
  const lastActivity = useSelector(_ => _.lastActivity);

  const { creationTime, lastSignInTime } = user.metadata;

  const subscribed = DateTime.fromHTTP(creationTime)
    .setLocale('fr')
    .toFormat('dd LLLL yyyy');

  const date = lastActivity
    ? DateTime.fromMillis(lastActivity)
    : DateTime.fromHTTP(lastSignInTime);

  const limit = DateTime.local().plus({ weeks: 2 });
  const label = lastActivity ? ' activité' : 'connexion';
  const relative = limit > date ? date.toRelative() : date.toLocaleString();
  return (
    <React.Fragment>
      <div
        className={classnames(
          classes.activity,
          'mb6 smart-maps-profile-activity'
        )}>
        <span className={classes.label}>Inscris depuis le&nbsp;:&nbsp;</span>
        <span className={classes.value}>{subscribed}</span>
      </div>
      <div
        className={classnames(classes.activity, 'smart-maps-profile-activity')}>
        <span className={classes.label}>
          Dernière&nbsp;{label}&nbsp;:&nbsp;
        </span>
        <span className={classes.value}>{relative}</span>
      </div>
    </React.Fragment>
  );
});

LastActivityComponent.displayName = 'LastActivityComponent';

export default LastActivityComponent;
